import styled, { css } from 'styled-components'

import { Placement } from '@popperjs/core'

export type StyledTooltipProps = {
  position: Placement
}

export type StyledTooltipDescriptionProps = {
  hasAction: boolean
}

export type StyledTooltipArrowProps = StyledTooltipProps & {
  isInteractive: boolean
}

const TooltipRegularText = styled.span`
  font-family: Inter;
  font-size: var(--tooltip-regular-font-size);
  line-height: 15px;
`

const TooltipBoldText = styled(TooltipRegularText)`
  font-weight: bold;
`

export const TooltipTitle = styled(TooltipBoldText)`
  color: var(--tooltip-title-text-color);
  margin-bottom: 4px;
`

export const TooltipDescription = styled(TooltipRegularText)<StyledTooltipDescriptionProps>`
  ${({ hasAction }) => css`
    color: var(--tooltip-description-text-color);
    margin-bottom: ${hasAction ? '16px' : '0'};
  `}
`

export const TooltipAction = styled(TooltipBoldText)`
  color: var(--tooltip-action-text-color);
  margin-left: auto;
  cursor: pointer;
`

export const TooltipArrow = styled.div<StyledTooltipArrowProps>`
  ${({ isInteractive }) => css`
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: var(--tooltip-arrow-background-color);
    border-radius: var(--tooltip-arrow-border-radius);
    transform: rotate(-135deg);
    pointer-events: ${isInteractive ? 'all' : 'none'};
  `}
`

export const Container = styled.div`
  position: relative;

  #tooltip {
    display: none;
  }

  #tooltip[data-show] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    z-index: var(--zIndexMinimum);
    padding: var(--tooltip-content-padding);
    background-color: var(--tooltip-content-background-color);
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.22);
    border-radius: var(--tooltip-content-border-radius);
    max-width: var(--tooltip-content-max-width);
  }

  #arrow,
  #arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
  }

  #arrow {
    visibility: hidden;
  }

  #arrow::before {
    visibility: visible;
    content: '';
    transform: rotate(45deg);
  }

  #tooltip[data-popper-placement^='top'] > #arrow {
    bottom: -4px;
  }

  #tooltip[data-popper-placement^='bottom'] > #arrow {
    top: -4px;
  }

  #tooltip[data-popper-placement^='left'] > #arrow {
    right: -4px;
  }

  #tooltip[data-popper-placement^='right'] > #arrow {
    left: -4px;
  }
`
